import {
  useAddFeedbackCommentMutation,
  useGetFeedbackCommentByFeedbackIdLazyQuery,
} from "graphql/__generated__/hooks";
import { useAuthUser } from "hooks/useAuthUser";
import { useEffect, useMemo } from "react";
import { useParams } from "react-router-dom";
import { VETCOIN_REWARDS, useVetcoin } from "hooks/useVetcoin";

export const useComments = () => {
  const [getComments, { data: commentsData }] =
    useGetFeedbackCommentByFeedbackIdLazyQuery();
  const [addFeedbackComment] = useAddFeedbackCommentMutation();

  const { feedbackId } = useParams();
  const { user } = useAuthUser();
  const { awardVetcoins } = useVetcoin(user?.user_id);
  const comments = useMemo(() => {
    return commentsData?.feedback_comment || [];
  }, [commentsData]);

  const fetchComments = async () => {
    if (feedbackId) {
      await getComments({ variables: { feedbackId } });
    }
  };

  useEffect(() => {
    fetchComments();
  }, [feedbackId]);

  const addComment = (comment: string) => {
    addFeedbackComment({
      variables: {
        feedback_id: feedbackId,
        user_id: user?.user_id,
        text: comment,
      },
    }).then(async () => {
      try {
        await awardVetcoins({
          userId: user?.user_id || "",
          amount: VETCOIN_REWARDS.FEEDBACK_COMMENT_CREATED,
          actionType: "FEEDBACK_COMMENT_CREATED",
          sourceFeedbackId: feedbackId,
          metadata: { flow: "feedback_comment" },
        });
      } catch (error) {
        console.error("Error awarding vetcoins for feedback comment:", error);
      }
      await fetchComments();
    });
  };

  return { comments, addComment };
};
